<template>
  <v-container class="my-5">
    <v-card class="elevation-3">
      <v-toolbar dark flat color="blue darken-3">
        <v-icon left>mdi-golf</v-icon>
        <v-toolbar-title>Casa Club</v-toolbar-title>
      </v-toolbar>

      <v-tabs v-model="activeTab" color="blue darken-3">
        <v-tab>
          <v-icon left>mdi-golf</v-icon>
          Jugadores de Torneo
        </v-tab>
        <v-tab>
          <v-icon left>mdi-account-multiple</v-icon>
          Socios
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
      <!-- TAB 1: JUGADORES DE TORNEO -->
      <v-tab-item>
        <v-card-text class="pt-5">
          <v-row class="mb-4">
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="searchTournament"
                prepend-inner-icon="mdi-magnify"
                label="Buscar por nombre, email o teléfono"
                outlined
                dense
                hide-details
                clearable
                color="blue darken-2"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select
                v-model="filterAttendance"
                :items="[
                  { text: 'Todos', value: null },
                  { text: 'Asistió', value: true },
                  { text: 'No asistió', value: false }
                ]"
                item-text="text"
                item-value="value"
                label="Estado de asistencia"
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" sm="3">
              <v-btn
                color="blue darken-2"
                dark
                block
                @click="fetchTournamentMembers"
                :loading="loadingTournament"
              >
                <v-icon left>mdi-refresh</v-icon>
                Actualizar
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headersTournament"
            :items="filteredTournamentMembers"
            :search="searchTournament"
            :loading="loadingTournament"
            :expanded.sync="expandedMembers"
            item-key="id"
            show-expand
            loading-text="Cargando jugadores..."
            no-data-text="No hay jugadores registrados"
            no-results-text="No se encontraron jugadores"
          >
            <template v-slot:item.data-table-expand></template>
            <template v-slot:item.tournament_name>
              Torneo infantil-juvenil primera etapa
            </template>
            <template v-slot:item.guest_count="{ item }">
              <v-chip
                v-if="item.guest_count > 0"
                small
                color="blue"
                text-color="white"
                style="cursor: pointer"
                @click="toggleGuests(item)"
              >
                +{{ item.guest_count }}
                <v-icon right x-small>{{ isExpanded(item) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-chip>
              <span v-else>—</span>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                color="blue darken-2"
                dark
                small
                @click="grantTournamentAccess(item)"
              >
                <v-icon left x-small>mdi-login</v-icon>
                ACCESO
              </v-btn>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="pa-0 guest-sublist-cell">
                <div
                  v-for="guest in item.guests"
                  :key="guest.id"
                  class="d-flex align-center justify-space-between guest-row px-4 py-2"
                >
                  <div class="d-flex align-center">
                    <v-icon small color="blue darken-2" class="mr-2">mdi-account-arrow-right</v-icon>
                    <span class="font-weight-medium">{{ guest.full_name }}</span>
                  </div>
                  <v-btn color="blue darken-2" dark @click="grantGuestAccess(guest, item)">
                    <v-icon left small>mdi-login</v-icon>
                    ACCESO
                  </v-btn>
                </div>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-tab-item>

      <!-- TAB 2: SOCIOS -->
      <v-tab-item>
        <v-card-text class="pt-5">
          <v-row class="mb-4">
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="searchName"
                prepend-inner-icon="mdi-magnify"
                label="Buscar por nombre"
                outlined
                dense
                hide-details
                clearable
                color="blue darken-2"
                @keyup.enter="searchSociosClick"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="searchSocio"
                prepend-inner-icon="mdi-magnify"
                label="Buscar por socio"
                outlined
                dense
                hide-details
                clearable
                color="blue darken-2"
                @keyup.enter="searchSociosClick"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select
                v-model="filterStatus"
                :items="[
                  { text: 'Todos', value: null },
                  { text: 'Activo', value: 'Activo' },
                  { text: 'Suspendido', value: 'Suspendido' },
                  { text: 'Baja', value: 'Baja' },
                  { text: 'Inactivo', value: 'Inactivo' }
                ]"
                item-text="text"
                item-value="value"
                label="Estado"
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" sm="2">
              <v-btn
                color="blue darken-2"
                dark
                block
                @click="searchSociosClick"
                :loading="loadingSocios"
              >
                <v-icon left>mdi-magnify</v-icon>
                Buscar
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headersSocios"
            :items="socios"
            :loading="loadingSocios"
            hide-default-footer
            loading-text="Cargando socios..."
            no-data-text="No hay socios registrados"
            no-results-text="No se encontraron socios"
          >
            <template v-slot:item.status="{ item }">
              <v-chip small :color="statusColor(displayStatus(item))" text-color="white" class="font-weight-bold">
                {{ displayStatus(item) }}
              </v-chip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn color="blue darken-2" dark @click="grantMemberAccess(item)">
                ACCESO
              </v-btn>
            </template>
          </v-data-table>

          <div class="d-flex align-center justify-space-between mt-3" v-if="sociosTotal > 0">
            <span class="text-caption grey--text">Total: {{ sociosTotal }} socios</span>
            <div>
              <v-btn icon small :disabled="sociosPage <= 1 || loadingSocios" @click="prevSociosPage">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <span class="mx-2 text-caption">Página {{ sociosPage }} de {{ sociosTotalPages }}</span>
              <v-btn icon small :disabled="sociosPage >= sociosTotalPages || loadingSocios" @click="nextSociosPage">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- Modal Acceso Socio (solo para preview, luego emite evento) -->
    <v-dialog v-model="dialogMemberAccess" persistent scrollable max-width="700px">
      <v-card v-if="selectedMember" class="elevation-8 tournament-preview-card">
        <v-toolbar dark flat class="tournament-toolbar" height="64">
          <v-icon left size="28">mdi-golf</v-icon>
          <v-toolbar-title class="text-subtitle-1 font-weight-bold">
            ACCESO SOCIO
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-chip :color="statusColor(displayStatus(selectedMember))" text-color="white" class="font-weight-bold" small>
            <v-icon left small>mdi-check-circle</v-icon>
            {{ displayStatus(selectedMember).toUpperCase() }}
          </v-chip>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-row no-gutters>
            <v-col cols="12" sm="7" class="pa-5">
              <div class="tournament-kicker">Socio del Club</div>
              <h2 class="tournament-name">{{ selectedMember.name }}</h2>
              <div class="tournament-event mb-4">{{ selectedMember.socio }}</div>
              <v-row dense>
                <v-col cols="12">
                  <div class="tournament-info-box">
                    <div class="info-label">Área</div>
                    <div class="info-value">Casa Club</div>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="tournament-info-box">
                    <div class="info-label">Fecha</div>
                    <div class="info-value">{{ currentDate }}</div>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="tournament-info-box">
                    <div class="info-label">Hora</div>
                    <div class="info-value">{{ currentTime }}</div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="5">
              <div class="member-photo-wrap">
                <img :src="require('../../assets/noimage.png')" class="member-photo-large" alt="Foto de perfil">
                <div class="member-accion-overlay">{{ selectedMember.id_dependiente }}</div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center pa-4">
          <v-btn large outlined color="error" @click="dialogMemberAccess = false">
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn large color="blue darken-2" dark @click="confirmMemberAccess">
            <v-icon left>mdi-login</v-icon>
            Permitir ingreso
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" color="success" :timeout="2500">
      <v-icon left>mdi-check-circle</v-icon>
      Acceso permitido
    </v-snackbar>
  </v-container>
</template>
<script>
const API_KEY = 'NK3ZlH8Jzhk4Vgwdti3cQ_VyG99v323seGTwozqtCgw'
const TOURNAMENT_API = 'https://club-services.intrare.app/temp-tournament-members/'
const CCSLP_USERS_API = 'https://club-services.intrare.app/ccslp/users/'
// Código del torneo infantil-juvenil actualmente en curso
const TOURNAMENT_CODE = 'kids_1788455854_h4RsKPKJwvM'

export default {
  name: 'CasaClub',
  data () {
    return {
      activeTab: 0,
      searchName: '',
      searchSocio: '',
      searchTournament: '',
      filterStatus: null,
      filterAttendance: null,
      dialogMemberAccess: false,
      selectedMember: null,
      snackbar: false,
      loadingSocios: false,
      loadingTournament: false,
      sociosPage: 1,
      sociosLimit: 100,
      sociosTotal: 0,

      headersSocios: [
        { text: 'Nombre', value: 'name' },
        { text: 'Socio', value: 'socio' },
        { text: 'ID Dependiente', value: 'id_dependiente' },
        { text: 'Status', value: 'status' },
        { text: 'Acceso', value: 'action', sortable: false, align: 'center' }
      ],

      headersTournament: [
        { text: 'Nombre', value: 'full_name' },
        { text: 'Club', value: 'club' },
        { text: 'Email', value: 'email' },
        { text: 'Teléfono', value: 'phone' },
        { text: 'Torneo', value: 'tournament_name' },
        { text: 'Invitados', value: 'guest_count', align: 'center' },
        { text: 'Acceso', value: 'action', sortable: false, align: 'center' }
      ],

      socios: [],
      tournamentMembers: [],
      expandedMembers: []
    }
  },

  computed: {
    currentDate () {
      return new Date().toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })
    },
    currentTime () {
      return new Date().toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) + ' hrs'
    },
    filteredTournamentMembers () {
      // Solo mostramos titulares (no invitados, parent_member !== null) del
      // torneo actual; los inscritos de torneos anteriores u otros torneos
      // no deben aparecer aquí.
      let filtered = this.tournamentMembers.filter(member =>
        !member.parent_member && member.tournament_code === TOURNAMENT_CODE
      )

      if (this.filterAttendance !== null) {
        filtered = filtered.filter(member => member.attended === this.filterAttendance)
      }

      return filtered
    },
    sociosTotalPages () {
      return this.sociosTotal > 0 ? Math.ceil(this.sociosTotal / this.sociosLimit) : 1
    }
  },

  mounted () {
    this.fetchTournamentMembers()
    this.fetchSocios()
  },

  methods: {
    displayStatus (item) {
      if (item.is_moroso) return 'Moroso'
      if (!item.status) return 'N/A'
      return item.status
    },

    statusColor (status) {
      switch (status) {
        case 'Activo':
          return 'green'
        case 'Suspendido':
          return 'red darken-1'
        case 'Baja':
          return 'grey darken-1'
        case 'Inactivo':
          return 'orange darken-1'
        case 'Moroso':
          return 'red darken-1'
        case 'N/A':
          return 'grey'
        default:
          return 'grey'
      }
    },

    grantMemberAccess (item) {
      this.selectedMember = item
      this.dialogMemberAccess = true
    },

    confirmMemberAccess () {
      const memberData = {
        full_name: this.selectedMember.name,
        tournament: 'Casa Club',
        email: '',
        phone: '',
        access_code: this.selectedMember.id_dependiente,
        area: this.selectedMember.socio || 'Casa Club',
        date: this.currentDate,
        time: this.currentTime
      }

      this.dialogMemberAccess = false
      this.goToTournamentCard(memberData)
    },

    grantTournamentAccess (member) {
      const tournamentData = {
        full_name: member.full_name,
        tournament: member.tournament_name || member.club,
        email: member.email,
        phone: member.phone,
        access_code: member.access_code,
        area: member.club,
        date: this.currentDate,
        time: this.currentTime
      }

      this.goToTournamentCard(tournamentData)
    },

    grantGuestAccess (guest, parentMember) {
      const tournamentData = {
        full_name: guest.full_name,
        tournament: 'Torneo infantil-juvenil primera etapa',
        email: '',
        phone: '',
        // Los invitados no traen access_code propio; usamos su id como
        // identificador único para esta card (revisar con backend si el
        // check-in de invitados necesita un endpoint/código distinto).
        access_code: guest.access_code || guest.id,
        area: parentMember.club,
        date: this.currentDate,
        time: this.currentTime
      }

      this.goToTournamentCard(tournamentData)
    },

    isExpanded (item) {
      return this.expandedMembers.some(member => member.id === item.id)
    },

    toggleGuests (item) {
      const index = this.expandedMembers.findIndex(member => member.id === item.id)
      if (index === -1) {
        this.expandedMembers.push(item)
      } else {
        this.expandedMembers.splice(index, 1)
      }
    },

    goToTournamentCard (tournamentAccess) {
      // La caseta seleccionada define si hay un tótem/dispositivo QR físico
      // asignado (ver Home.vue -> getDevicesByGuardHouse, banderaQR). Si lo
      // hay, delegamos el registro a checkin_checkout_qr2 (única vista de
      // tótem con soporte de torneo); si no, se registra con la cámara local
      // en access_without_code, igual que EVENTO/DELIVERY en events.vue.
      let qrDevice = false
      if (localStorage.getItem('banderaQR') !== null) {
        qrDevice = localStorage.getItem('banderaQR') === 'true'
      }

      if (qrDevice) {
        // checkin_checkout_qr2 aún no está montada al navegar, por lo que un
        // $root.$emit aquí se perdería (nadie está escuchando todavía). En su
        // lugar mandamos los datos por route params, igual que EVENTO/DELIVERY,
        // y checkin_checkout_qr2 los toma en su hook created().
        this.$router.push({
          name: 'checkin_checkout_qr2',
          params: {
            type: 2,
            tournamentAccess
          }
        })
      } else {
        this.$router.push({
          name: 'access_without_code',
          params: {
            fullNameGuest: tournamentAccess.full_name,
            idGuestByTournament: tournamentAccess.access_code,
            tournamentName: tournamentAccess.tournament,
            type: 4
          }
        })
      }
    },

    searchSociosClick () {
      this.sociosPage = 1
      this.fetchSocios()
    },

    prevSociosPage () {
      if (this.sociosPage > 1) {
        this.sociosPage--
        this.fetchSocios()
      }
    },

    nextSociosPage () {
      if (this.sociosPage < this.sociosTotalPages) {
        this.sociosPage++
        this.fetchSocios()
      }
    },

    fetchSocios () {
      this.loadingSocios = true
      const params = {
        api_key: API_KEY,
        limit: this.sociosLimit,
        offset: (this.sociosPage - 1) * this.sociosLimit
      }
      if (this.searchName) params.name = this.searchName
      if (this.searchSocio) params.socio = this.searchSocio
      if (this.filterStatus) params.status = this.filterStatus

      const config = {
        method: 'get',
        url: CCSLP_USERS_API,
        params
      }

      this.$axios(config)
        .then(response => {
          this.socios = (response.data && response.data.users) || []
          this.sociosTotal = (response.data && response.data.total) || 0
        })
        .catch(error => {
          console.error('Error fetching CCSLP users:', error)
          this.$store.commit('snackbar_change_color', 'error')
          this.$store.commit('snackbar_change_message', 'Error al cargar socios')
          this.$store.commit('snackbar_activate_true')
        })
        .finally(() => {
          this.loadingSocios = false
        })
    },

    fetchTournamentMembers () {
      this.loadingTournament = true
      const config = {
        method: 'get',
        url: TOURNAMENT_API,
        params: {
          api_key: API_KEY,
          tournament_code: TOURNAMENT_CODE
        }
      }

      this.$axios(config)
        .then(response => {
          this.tournamentMembers = response.data || []
        })
        .catch(error => {
          console.error('Error fetching tournament members:', error)
          this.$store.commit('snackbar_change_color', 'error')
          this.$store.commit('snackbar_change_message', 'Error al cargar jugadores de torneo')
          this.$store.commit('snackbar_activate_true')
        })
        .finally(() => {
          this.loadingTournament = false
        })
    }
  }
}
</script>

<style scoped>
.guest-sublist-cell {
  background: #f5f8fc;
  border-left: 3px solid #1565C0;
}

.guest-row:not(:last-child) {
  border-bottom: 1px solid rgba(21, 101, 192, 0.1);
}

.tournament-preview-card {
  border-radius: 16px;
  overflow: hidden;
  background: linear-gradient(180deg, #f2f7fd 0%, #ffffff 100%);
}

.tournament-toolbar {
  background: #1565C0 !important;
}

.tournament-kicker {
  color: #1565C0;
  font-size: 0.68rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 4px;
}

.tournament-name {
  font-size: clamp(1.3rem, 1.8vw, 1.6rem);
  line-height: 1.25;
  margin: 0;
  color: #212121;
  font-weight: 700;
}

.tournament-event {
  margin-top: 6px;
  font-size: 0.9rem;
  color: #616161;
  font-weight: 500;
  text-transform: capitalize;
}

.tournament-info-box {
  background: #eaf2fb;
  border: 1px solid rgba(21, 101, 192, 0.15);
  border-radius: 10px;
  padding: 10px 14px;
  min-height: 66px;
  margin-bottom: 12px;
}

.info-label {
  font-size: 0.66rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #0D47A1;
  font-weight: 700;
  margin-bottom: 4px;
}

.info-value {
  font-size: 0.98rem;
  line-height: 1.35;
  color: #263238;
  font-weight: 600;
  word-break: break-word;
}

.member-photo-wrap {
  position: relative;
  height: 100%;
  min-height: 280px;
}

.member-photo-large {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.member-accion-overlay {
  position: absolute;
  bottom: 14px;
  right: 14px;
  background: rgba(13, 71, 161, 0.88);
  color: #ffffff;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.08em;
}
</style>
